import { render } from "./TipoMedicaoSelect.vue?vue&type=template&id=2a968777"
import script from "./TipoMedicaoSelect.vue?vue&type=script&lang=js"
export * from "./TipoMedicaoSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__